import { useEffect, useState, useMemo } from 'react';
import { isMaxWidth } from './helpers';
export function useDidMount(closure) {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(closure, []);
}
export function useIsBreakpoint(breakpoint) {
  const [isMobileValue, setIsMobile] = useState(isMaxWidth(breakpoint));
  useDidMount(() => {
    const updateIsMobile = () => setIsMobile(isMaxWidth(breakpoint));
    window.addEventListener('resize', updateIsMobile);
    return () => window.removeEventListener('resize', updateIsMobile);
  });
  return isMobileValue;
}
export function useClickAway(ref, handler) {
  const refs = useMemo(() => Array.isArray(ref) ? ref : [ref], [ref]);
  useEffect(() => {
    const listener = event => {
      if (!refs.length || refs.find(({
        current
      }) => current && current.contains(event.target))) return;
      handler(event);
    };
    document.addEventListener('mousedown', listener);
    document.addEventListener('touchstart', listener);
    return () => {
      document.removeEventListener('mousedown', listener);
      document.removeEventListener('touchstart', listener);
    };
  }, [ref, handler, refs]);
}
export function useEscAway(ref, handler) {
  const refs = useMemo(() => Array.isArray(ref) ? ref : [ref], [ref]);
  useEffect(() => {
    const listener = event => {
      if (!refs.length || event.which !== 27 || event.keyCode !== 27) return;
      handler(event);
    };
    document.addEventListener('keydown', listener);
    return () => {
      document.removeEventListener('keydown', listener);
    };
  }, [ref, handler, refs]);
}
//# sourceMappingURL=hooks.js.map